import { render, staticRenderFns } from "./u-btn-outlined-tile-arrow.vue?vue&type=template&id=5cda41b2&scoped=true&"
import script from "./u-btn-outlined-tile-arrow.vue?vue&type=script&lang=js&"
export * from "./u-btn-outlined-tile-arrow.vue?vue&type=script&lang=js&"
import style0 from "./u-btn-outlined-tile-arrow.vue?vue&type=style&index=0&id=5cda41b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cda41b2",
  null
  
)

export default component.exports